import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "c-advanced-search__inner",
  "data-lenis-prevent": ""
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "c-advanced-search__content" }
const _hoisted_6 = { class: "o-form" }
const _hoisted_7 = { class: "o-form__item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "programmes-search"
}, "Mots clés", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-search",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "search"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search" })
], -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer -spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "c-advanced-search__row" }
const _hoisted_12 = { class: "c-advanced-search__item" }
const _hoisted_13 = {
  key: 0,
  id: "title-1",
  class: "c-advanced-search__mobile-accordion"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "c-advanced-search__item__title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "o-title-5" }, " Année "),
  /*#__PURE__*/_createElementVNode("button", {
    class: "c-advanced-search__accordion__toggler",
    "data-module": "ClassToggle",
    "data-target": "#title-1",
    "data-class": "is-open"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-down",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_15 = { class: "c-advanced-search__item__filters" }
const _hoisted_16 = { class: "c-advanced-search__item__filters__inner" }
const _hoisted_17 = { class: "o-checkbox__wrap" }
const _hoisted_18 = ["id", "value"]
const _hoisted_19 = ["for"]
const _hoisted_20 = {
  key: 1,
  id: "title-2",
  class: "c-advanced-search__mobile-accordion"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "c-advanced-search__item__title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "o-title-5" }, " Formats "),
  /*#__PURE__*/_createElementVNode("button", {
    class: "c-advanced-search__accordion__toggler",
    "data-module": "ClassToggle",
    "data-target": "#title-2",
    "data-class": "is-open"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-down",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_22 = { class: "c-advanced-search__item__filters" }
const _hoisted_23 = { class: "c-advanced-search__item__filters__inner" }
const _hoisted_24 = { class: "o-checkbox__wrap" }
const _hoisted_25 = ["id", "value"]
const _hoisted_26 = ["for"]
const _hoisted_27 = {
  key: 0,
  class: "c-advanced-search__item"
}
const _hoisted_28 = {
  id: "title-3",
  class: "c-advanced-search__mobile-accordion"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "c-advanced-search__item__title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "o-title-5" }, " Je suis "),
  /*#__PURE__*/_createElementVNode("button", {
    class: "c-advanced-search__accordion__toggler",
    "data-module": "ClassToggle",
    "data-target": "#title-3",
    "data-class": "is-open"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-down",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_30 = { class: "c-advanced-search__item__filters" }
const _hoisted_31 = { class: "c-advanced-search__item__filters__inner" }
const _hoisted_32 = { class: "o-checkbox__wrap" }
const _hoisted_33 = ["id", "value"]
const _hoisted_34 = ["for"]
const _hoisted_35 = {
  id: "title-4",
  class: "c-advanced-search__mobile-accordion"
}
const _hoisted_36 = { class: "c-advanced-search__item__title" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "o-title-5" }, " Thématiques ", -1 /* HOISTED */)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "c-advanced-search__item__filters" }
const _hoisted_41 = { class: "c-advanced-search__item__filters__inner" }
const _hoisted_42 = {
  key: 0,
  class: "c-advanced-search__accordion"
}
const _hoisted_43 = { class: "c-advanced-search__accordion__head" }
const _hoisted_44 = { class: "o-checkbox__wrap" }
const _hoisted_45 = ["id", "value"]
const _hoisted_46 = ["for"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 0,
  class: "c-advanced-search__accordion__content"
}
const _hoisted_51 = { class: "c-advanced-search__accordion__content__inner" }
const _hoisted_52 = {
  key: 0,
  class: "o-checkbox__wrap"
}
const _hoisted_53 = ["id", "value"]
const _hoisted_54 = ["for"]
const _hoisted_55 = { class: "c-advanced-search__accordion__head" }
const _hoisted_56 = { class: "o-checkbox__wrap" }
const _hoisted_57 = ["id", "value"]
const _hoisted_58 = ["for"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "c-advanced-search__accordion__content" }
const _hoisted_63 = { class: "c-advanced-search__accordion__content__inner" }
const _hoisted_64 = {
  key: 0,
  class: "o-checkbox__wrap"
}
const _hoisted_65 = ["id", "value"]
const _hoisted_66 = ["for"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer -spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_68 = { class: "c-advanced-search__buttons" }
const _hoisted_69 = { class: "c-programmes-search__filters__reset" }
const _hoisted_70 = { class: "c-programmes-search__filters__apply" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "c-advanced-search__bg",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.toggleAdvancedSearch()), ["prevent"]))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "c-advanced-search__close js-advanced-search__focus",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.toggleAdvancedSearch()), ["prevent"])),
        "aria-label": "Ouvrir et/ou fermer la recherche"
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              onKeyup: _cache[2] || (_cache[2] = $event => ($options.keyupSearch())),
              class: "o-input",
              id: "programmes-search",
              type: "text",
              placeholder: "Mots clés",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.searchInput) = $event))
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
              [_vModelText, $data.searchInput]
            ]),
            _hoisted_9
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              ($data.years.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.years, (year) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _withDirectives(_createElementVNode("input", {
                              onChange: _cache[4] || (_cache[4] = $event => ($options.updateAttributes())),
                              id: 'year'+year,
                              class: "o-checkbox",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.selectedYears) = $event)),
                              value: year
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_18), [
                              [_vModelCheckbox, $data.selectedYears]
                            ]),
                            _createElementVNode("label", {
                              class: "o-checkbox-label",
                              for: 'year'+year
                            }, _toDisplayString(year), 9 /* TEXT, PROPS */, _hoisted_19)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              ($data.formats.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formats, (format) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _withDirectives(_createElementVNode("input", {
                              onChange: _cache[6] || (_cache[6] = $event => ($options.updateAttributes())),
                              id: 'format'+format.id,
                              class: "o-checkbox",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.selectedFormats) = $event)),
                              value: format.id
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_25), [
                              [_vModelCheckbox, $data.selectedFormats]
                            ]),
                            _createElementVNode("label", {
                              class: "o-checkbox-label",
                              for: 'format'+format.id
                            }, _toDisplayString(format.title), 9 /* TEXT, PROPS */, _hoisted_26)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            ($data.jesuis.length>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.jesuis, (je) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _withDirectives(_createElementVNode("input", {
                              onChange: _cache[8] || (_cache[8] = $event => ($options.updateAttributes())),
                              id: 'jesuis'+je.id,
                              class: "o-checkbox",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.selectedJesuis) = $event)),
                              value: je.id
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_33), [
                              [_vModelCheckbox, $data.selectedJesuis]
                            ]),
                            _createElementVNode("label", {
                              class: "o-checkbox-label",
                              for: 'jesuis'+je.id
                            }, _toDisplayString(je.title), 9 /* TEXT, PROPS */, _hoisted_34)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.categories.length>0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["c-advanced-search__item", {'is-open': $data.thematique}])
                }, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("button", {
                        class: "c-advanced-search__accordion__toggler",
                        onClick: _cache[10] || (_cache[10] = _withModifiers($event => ($data.thematique=!$data.thematique), ["prevent"]))
                      }, _hoisted_39)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.categories, (category) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (category.parent===null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["c-advanced-search__accordion__item", {'is-open': $data.accordions.includes(category.id)}])
                                  }, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        _withDirectives(_createElementVNode("input", {
                                          onChange: _cache[11] || (_cache[11] = $event => ($options.updateAttributes())),
                                          class: "o-checkbox",
                                          type: "checkbox",
                                          id: 'cat'+category.id,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($data.selectedCategories) = $event)),
                                          value: category.id
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_45), [
                                          [_vModelCheckbox, $data.selectedCategories]
                                        ]),
                                        _createElementVNode("label", {
                                          class: "o-checkbox-label",
                                          for: 'cat'+category.id
                                        }, _toDisplayString(category.title), 9 /* TEXT, PROPS */, _hoisted_46)
                                      ]),
                                      ($options.hasChilds(category))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "c-advanced-search__accordion__toggler",
                                            onClick: _withModifiers($event => ($options.toggleAccordion(category)), ["prevent"])
                                          }, _hoisted_49, 8 /* PROPS */, _hoisted_47))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    ($options.hasChilds(category))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                          _createElementVNode("div", _hoisted_51, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.categories, (child) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                (child.parent===category.id && !$options.hasChilds(child))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        onChange: _cache[13] || (_cache[13] = $event => ($options.updateAttributes())),
                                                        class: "o-checkbox",
                                                        type: "checkbox",
                                                        id: 'cat'+child.id,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.selectedCategories) = $event)),
                                                        value: child.id
                                                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_53), [
                                                        [_vModelCheckbox, $data.selectedCategories]
                                                      ]),
                                                      _createElementVNode("label", {
                                                        class: "o-checkbox-label",
                                                        for: 'cat'+child.id
                                                      }, _toDisplayString(child.title), 9 /* TEXT, PROPS */, _hoisted_54)
                                                    ]))
                                                  : (child.parent===category.id && $options.hasChilds(child))
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 1,
                                                        class: _normalizeClass(["c-advanced-search__accordion__item", {'is-open': $data.accordions.includes(child.id)}])
                                                      }, [
                                                        _createElementVNode("div", _hoisted_55, [
                                                          _createElementVNode("div", _hoisted_56, [
                                                            _withDirectives(_createElementVNode("input", {
                                                              onChange: _cache[15] || (_cache[15] = $event => ($options.updateAttributes())),
                                                              class: "o-checkbox",
                                                              type: "checkbox",
                                                              id: 'cat'+child.id,
                                                              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($data.selectedCategories) = $event)),
                                                              value: child.id
                                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_57), [
                                                              [_vModelCheckbox, $data.selectedCategories]
                                                            ]),
                                                            _createElementVNode("label", {
                                                              class: "o-checkbox-label",
                                                              for: 'cat'+child.id
                                                            }, _toDisplayString(child.title), 9 /* TEXT, PROPS */, _hoisted_58)
                                                          ]),
                                                          _createElementVNode("button", {
                                                            class: "c-advanced-search__accordion__toggler",
                                                            onClick: _withModifiers($event => ($options.toggleAccordion(child)), ["prevent"])
                                                          }, _hoisted_61, 8 /* PROPS */, _hoisted_59)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_62, [
                                                          _createElementVNode("div", _hoisted_63, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.categories, (subchild) => {
                                                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                                (subchild.parent==child.id)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                                      _withDirectives(_createElementVNode("input", {
                                                                        onChange: _cache[17] || (_cache[17] = $event => ($options.updateAttributes())),
                                                                        class: "o-checkbox",
                                                                        type: "checkbox",
                                                                        id: 'cat'+subchild.id,
                                                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($data.selectedCategories) = $event)),
                                                                        value: subchild.id
                                                                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_65), [
                                                                        [_vModelCheckbox, $data.selectedCategories]
                                                                      ]),
                                                                      _createElementVNode("label", {
                                                                        class: "o-checkbox-label",
                                                                        for: 'cat'+subchild.id
                                                                      }, _toDisplayString(subchild.title), 9 /* TEXT, PROPS */, _hoisted_66)
                                                                    ]))
                                                                  : _createCommentVNode("v-if", true)
                                                              ], 64 /* STABLE_FRAGMENT */))
                                                            }), 256 /* UNKEYED_FRAGMENT */))
                                                          ])
                                                        ])
                                                      ], 2 /* CLASS */))
                                                    : _createCommentVNode("v-if", true)
                                              ], 64 /* STABLE_FRAGMENT */))
                                            }), 256 /* UNKEYED_FRAGMENT */))
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ], 2 /* CLASS */)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ])
                  ])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ]),
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("button", {
                class: "o-button -button-reset",
                onClick: _cache[19] || (_cache[19] = _withModifiers($event => ($options.reset()), ["prevent"]))
              }, " Réinitialiser la recherche ")
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("button", {
                onClick: _cache[20] || (_cache[20] = _withModifiers($event => ($options.toggleAdvancedSearch()), ["prevent"])),
                class: "o-button -button-apply-filters"
              }, " Consulter les " + _toDisplayString($data.results) + " résultats ", 1 /* TEXT */)
            ])
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}